var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[_c('v-container',{staticClass:"background",attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50","color":"secondary"}})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }